//# sourceMappingURL=store.mjs.map
/// <reference types="./store.d.mts" />
import * as $auth0 from "../../auth0_client/auth0/client.mjs";
import * as $ai_config from "../../data_types/data/ai_config.mjs";
import * as $connection from "../../data_types/data/auth/connection.mjs";
import * as $invitation from "../../data_types/data/auth/invitation.mjs";
import * as $organization from "../../data_types/data/auth/organization.mjs";
import * as $role from "../../data_types/data/auth/role.mjs";
import * as $user_id from "../../data_types/data/auth/user_id.mjs";
import * as $data_point from "../../data_types/data/data_point.mjs";
import * as $wss_connected from "../../data_types/data/ephemeral/wss_connected.mjs";
import * as $llm_capacity from "../../data_types/data/llm_capacity.mjs";
import * as $metrics from "../../data_types/data/metrics.mjs";
import * as $page from "../../data_types/data/page.mjs";
import * as $project from "../../data_types/data/project.mjs";
import * as $project_file from "../../data_types/data/project_file.mjs";
import * as $proposal from "../../data_types/data/proposal.mjs";
import * as $proposal_element from "../../data_types/data/proposal_element.mjs";
import * as $answer from "../../data_types/data/proposal_element/answer.mjs";
import * as $qualification_matrix from "../../data_types/data/qualification_matrix.mjs";
import * as $remote from "../../data_types/data/remote.mjs";
import * as $tag from "../../data_types/data/tag.mjs";
import * as $translate from "../../data_types/data/translate.mjs";
import * as $language from "../../data_types/data/translate/language.mjs";
import * as $user from "../../data_types/data/user.mjs";
import { User } from "../../data_types/data/user.mjs";
import * as $weaviate from "../../data_types/data/weaviate.mjs";
import * as $promise from "../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $lustre from "../../redraw_lustre/redraw/lustre.mjs";
import * as $effect from "../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $content_library from "../data/content_library.mjs";
import * as $data_sources from "../data/data_sources.mjs";
import * as $llm_usage from "../data/llm_usage.mjs";
import * as $maintenance_mode from "../data/maintenance_mode.mjs";
import * as $msg from "../data/msg.mjs";
import * as $route from "../data/route.mjs";
import * as $loading from "../data/ui/loading.mjs";
import * as $dataset from "../elements/charts/dataset.mjs";
import { Ok, toList, CustomType as $CustomType, isEqual } from "../gleam.mjs";

export class Store extends $CustomType {
  constructor(connections, organizations, organizations_tags, organizations_users, organizations_invitations, organizations_enabled_connections, organizations_ai_config, organizations_qm_rows, connected_sockets, projects, proposals, page_index, proposal_elements, answers, translations, label_translations, label_translations_search, label_translations_language_filter, label_translations_sort, llm_rate_limits, organizations_activity, llm_usage, llm_usage_by_org, client, organization, route, user, user_id, content_library, ingestion_control_sources, ingestion_control_sources_visibility, loading, users, roles, maintenance_mode, data_sources, analytics, metrics_groups, dashboard_options, project_files, weaviate_migrations, weaviate_collections, sitemap_urls) {
    super();
    this.connections = connections;
    this.organizations = organizations;
    this.organizations_tags = organizations_tags;
    this.organizations_users = organizations_users;
    this.organizations_invitations = organizations_invitations;
    this.organizations_enabled_connections = organizations_enabled_connections;
    this.organizations_ai_config = organizations_ai_config;
    this.organizations_qm_rows = organizations_qm_rows;
    this.connected_sockets = connected_sockets;
    this.projects = projects;
    this.proposals = proposals;
    this.page_index = page_index;
    this.proposal_elements = proposal_elements;
    this.answers = answers;
    this.translations = translations;
    this.label_translations = label_translations;
    this.label_translations_search = label_translations_search;
    this.label_translations_language_filter = label_translations_language_filter;
    this.label_translations_sort = label_translations_sort;
    this.llm_rate_limits = llm_rate_limits;
    this.organizations_activity = organizations_activity;
    this.llm_usage = llm_usage;
    this.llm_usage_by_org = llm_usage_by_org;
    this.client = client;
    this.organization = organization;
    this.route = route;
    this.user = user;
    this.user_id = user_id;
    this.content_library = content_library;
    this.ingestion_control_sources = ingestion_control_sources;
    this.ingestion_control_sources_visibility = ingestion_control_sources_visibility;
    this.loading = loading;
    this.users = users;
    this.roles = roles;
    this.maintenance_mode = maintenance_mode;
    this.data_sources = data_sources;
    this.analytics = analytics;
    this.metrics_groups = metrics_groups;
    this.dashboard_options = dashboard_options;
    this.project_files = project_files;
    this.weaviate_migrations = weaviate_migrations;
    this.weaviate_collections = weaviate_collections;
    this.sitemap_urls = sitemap_urls;
  }
}
export const Store$Store = (connections, organizations, organizations_tags, organizations_users, organizations_invitations, organizations_enabled_connections, organizations_ai_config, organizations_qm_rows, connected_sockets, projects, proposals, page_index, proposal_elements, answers, translations, label_translations, label_translations_search, label_translations_language_filter, label_translations_sort, llm_rate_limits, organizations_activity, llm_usage, llm_usage_by_org, client, organization, route, user, user_id, content_library, ingestion_control_sources, ingestion_control_sources_visibility, loading, users, roles, maintenance_mode, data_sources, analytics, metrics_groups, dashboard_options, project_files, weaviate_migrations, weaviate_collections, sitemap_urls) =>
  new Store(connections,
  organizations,
  organizations_tags,
  organizations_users,
  organizations_invitations,
  organizations_enabled_connections,
  organizations_ai_config,
  organizations_qm_rows,
  connected_sockets,
  projects,
  proposals,
  page_index,
  proposal_elements,
  answers,
  translations,
  label_translations,
  label_translations_search,
  label_translations_language_filter,
  label_translations_sort,
  llm_rate_limits,
  organizations_activity,
  llm_usage,
  llm_usage_by_org,
  client,
  organization,
  route,
  user,
  user_id,
  content_library,
  ingestion_control_sources,
  ingestion_control_sources_visibility,
  loading,
  users,
  roles,
  maintenance_mode,
  data_sources,
  analytics,
  metrics_groups,
  dashboard_options,
  project_files,
  weaviate_migrations,
  weaviate_collections,
  sitemap_urls);
export const Store$isStore = (value) => value instanceof Store;
export const Store$Store$connections = (value) => value.connections;
export const Store$Store$0 = (value) => value.connections;
export const Store$Store$organizations = (value) => value.organizations;
export const Store$Store$1 = (value) => value.organizations;
export const Store$Store$organizations_tags = (value) =>
  value.organizations_tags;
export const Store$Store$2 = (value) => value.organizations_tags;
export const Store$Store$organizations_users = (value) =>
  value.organizations_users;
export const Store$Store$3 = (value) => value.organizations_users;
export const Store$Store$organizations_invitations = (value) =>
  value.organizations_invitations;
export const Store$Store$4 = (value) => value.organizations_invitations;
export const Store$Store$organizations_enabled_connections = (value) =>
  value.organizations_enabled_connections;
export const Store$Store$5 = (value) => value.organizations_enabled_connections;
export const Store$Store$organizations_ai_config = (value) =>
  value.organizations_ai_config;
export const Store$Store$6 = (value) => value.organizations_ai_config;
export const Store$Store$organizations_qm_rows = (value) =>
  value.organizations_qm_rows;
export const Store$Store$7 = (value) => value.organizations_qm_rows;
export const Store$Store$connected_sockets = (value) => value.connected_sockets;
export const Store$Store$8 = (value) => value.connected_sockets;
export const Store$Store$projects = (value) => value.projects;
export const Store$Store$9 = (value) => value.projects;
export const Store$Store$proposals = (value) => value.proposals;
export const Store$Store$10 = (value) => value.proposals;
export const Store$Store$page_index = (value) => value.page_index;
export const Store$Store$11 = (value) => value.page_index;
export const Store$Store$proposal_elements = (value) => value.proposal_elements;
export const Store$Store$12 = (value) => value.proposal_elements;
export const Store$Store$answers = (value) => value.answers;
export const Store$Store$13 = (value) => value.answers;
export const Store$Store$translations = (value) => value.translations;
export const Store$Store$14 = (value) => value.translations;
export const Store$Store$label_translations = (value) =>
  value.label_translations;
export const Store$Store$15 = (value) => value.label_translations;
export const Store$Store$label_translations_search = (value) =>
  value.label_translations_search;
export const Store$Store$16 = (value) => value.label_translations_search;
export const Store$Store$label_translations_language_filter = (value) =>
  value.label_translations_language_filter;
export const Store$Store$17 = (value) =>
  value.label_translations_language_filter;
export const Store$Store$label_translations_sort = (value) =>
  value.label_translations_sort;
export const Store$Store$18 = (value) => value.label_translations_sort;
export const Store$Store$llm_rate_limits = (value) => value.llm_rate_limits;
export const Store$Store$19 = (value) => value.llm_rate_limits;
export const Store$Store$organizations_activity = (value) =>
  value.organizations_activity;
export const Store$Store$20 = (value) => value.organizations_activity;
export const Store$Store$llm_usage = (value) => value.llm_usage;
export const Store$Store$21 = (value) => value.llm_usage;
export const Store$Store$llm_usage_by_org = (value) => value.llm_usage_by_org;
export const Store$Store$22 = (value) => value.llm_usage_by_org;
export const Store$Store$client = (value) => value.client;
export const Store$Store$23 = (value) => value.client;
export const Store$Store$organization = (value) => value.organization;
export const Store$Store$24 = (value) => value.organization;
export const Store$Store$route = (value) => value.route;
export const Store$Store$25 = (value) => value.route;
export const Store$Store$user = (value) => value.user;
export const Store$Store$26 = (value) => value.user;
export const Store$Store$user_id = (value) => value.user_id;
export const Store$Store$27 = (value) => value.user_id;
export const Store$Store$content_library = (value) => value.content_library;
export const Store$Store$28 = (value) => value.content_library;
export const Store$Store$ingestion_control_sources = (value) =>
  value.ingestion_control_sources;
export const Store$Store$29 = (value) => value.ingestion_control_sources;
export const Store$Store$ingestion_control_sources_visibility = (value) =>
  value.ingestion_control_sources_visibility;
export const Store$Store$30 = (value) =>
  value.ingestion_control_sources_visibility;
export const Store$Store$loading = (value) => value.loading;
export const Store$Store$31 = (value) => value.loading;
export const Store$Store$users = (value) => value.users;
export const Store$Store$32 = (value) => value.users;
export const Store$Store$roles = (value) => value.roles;
export const Store$Store$33 = (value) => value.roles;
export const Store$Store$maintenance_mode = (value) => value.maintenance_mode;
export const Store$Store$34 = (value) => value.maintenance_mode;
export const Store$Store$data_sources = (value) => value.data_sources;
export const Store$Store$35 = (value) => value.data_sources;
export const Store$Store$analytics = (value) => value.analytics;
export const Store$Store$36 = (value) => value.analytics;
export const Store$Store$metrics_groups = (value) => value.metrics_groups;
export const Store$Store$37 = (value) => value.metrics_groups;
export const Store$Store$dashboard_options = (value) => value.dashboard_options;
export const Store$Store$38 = (value) => value.dashboard_options;
export const Store$Store$project_files = (value) => value.project_files;
export const Store$Store$39 = (value) => value.project_files;
export const Store$Store$weaviate_migrations = (value) =>
  value.weaviate_migrations;
export const Store$Store$40 = (value) => value.weaviate_migrations;
export const Store$Store$weaviate_collections = (value) =>
  value.weaviate_collections;
export const Store$Store$41 = (value) => value.weaviate_collections;
export const Store$Store$sitemap_urls = (value) => value.sitemap_urls;
export const Store$Store$42 = (value) => value.sitemap_urls;

export const use_state = $lustre.use_state;

export const use_dispatch = $lustre.use_dispatch;

export const use_effect_dispatch = $lustre.use_effect_dispatch;

export const use_selector = $lustre.use_selector;

export function new$(client, route) {
  return new Store(
    new $remote.NotLoaded(),
    new $remote.NotLoaded(),
    $dict.new$(),
    $dict.new$(),
    $dict.new$(),
    $dict.new$(),
    $dict.new$(),
    $dict.new$(),
    new $remote.NotLoaded(),
    new $remote.NotLoaded(),
    new $remote.NotLoaded(),
    0,
    $dict.new$(),
    $dict.new$(),
    $dict.new$(),
    new $remote.NotLoaded(),
    new None(),
    new None(),
    "label_asc",
    new $remote.NotLoaded(),
    $dict.new$(),
    $dict.new$(),
    $dict.new$(),
    client,
    new None(),
    route,
    new None(),
    new None(),
    $content_library.new$(),
    $dict.new$(),
    $dict.new$(),
    $loading.new$(),
    toList([]),
    new $remote.NotLoaded(),
    $maintenance_mode.new$(),
    $data_sources.new$(),
    toList([]),
    toList([]),
    new $dataset.Options(true, "line"),
    $dict.new$(),
    $dict.new$(),
    $dict.new$(),
    new $remote.NotLoaded(),
  );
}

export function update_route(store, route) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function update_connected_user(store, user) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    new Some(user),
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_user_id(store, user_id) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    new Some(user_id),
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function is_connected(store) {
  return $option.is_some(store.user);
}

export function mark_as_loaded(store, mapper) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    mapper(store.loading),
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_maintenance_mode(store, maintenance_mode) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_weaviate_migrations(store, weaviate_migrations) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_llm_rate_limits(store, llm_rate_limits) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_organizations_activity(store, organizations_activity) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_llm_usage(store, llm_usage) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_llm_usage_by_org(store, llm_usage_by_org) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_weaviate_collections(store, weaviate_collections) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_sitemap_urls(store, sitemap_urls) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    sitemap_urls,
  );
}

export function set_content_library(store, content_library) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_data_sources(store, data_sources) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_ingestion_control_sources(store, ingestion_control_sources) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_ingestion_control_sources_visibility(
  store,
  ingestion_control_sources_visibility
) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function toggle_visibility(store, source_id) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    $dict.insert(
      store.ingestion_control_sources_visibility,
      source_id,
      (() => {
        let _pipe = store.ingestion_control_sources_visibility;
        let _pipe$1 = $dict.get(_pipe, source_id);
        let _pipe$2 = $result.unwrap(_pipe$1, false);
        return $bool.negate(_pipe$2);
      })(),
    ),
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

function sort_by_name(a, b) {
  return $string.compare(a.name, b.name);
}

export function set_organizations(store, organizations) {
  let _block;
  let _pipe = organizations;
  _block = $remote.map(
    _pipe,
    (_capture) => {
      return $pair.map_second(
        _capture,
        (_capture) => { return $list.sort(_capture, sort_by_name); },
      );
    },
  );
  let organizations$1 = _block;
  return new Store(
    store.connections,
    organizations$1,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_organizations_tags(store, organizations_tags) {
  return new Store(
    store.connections,
    store.organizations,
    organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_organizations_users(store, organizations_users) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_organizations_invitations(store, organizations_invitations) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_organizations_enabled_connections(
  store,
  organizations_enabled_connections
) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_organizations_ai_config(store, organizations_ai_config) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_organizations_qm_rows(store, organizations_qm_rows) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_ai_config(store, ai_config) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    $dict.insert(
      store.organizations_ai_config,
      ai_config.org_id,
      new $remote.Loaded(ai_config),
    ),
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function update_org_user(store, user_id, function$) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    store.organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    $list.map(
      store.users,
      (user) => {
        return $bool.guard(
          !isEqual(user.id, user_id),
          user,
          () => {
            return new User(
              user.id,
              user.name,
              user.email,
              user.preferences,
              user.picture,
              user.initials,
              user.roles,
              new Some(function$),
            );
          },
        );
      },
    ),
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

/**
 * The caller, among the organization's members.
 *
 * Both sides are local user ids: `store.user_id` is what the API resolved for
 * the token, and `User.id` is what the columns hold. Matching the token's
 * `sub` here instead would work until the first account rename.
 */
export function find_current_user(store) {
  return $list.find(
    store.users,
    (user) => { return isEqual(new Some(user.id), store.user_id); },
  );
}

export function find_current_user_id(store) {
  let user = find_current_user(store);
  return $result.map(user, (user) => { return user.id; });
}

export function current_organization(store) {
  let $ = store.organization;
  let $1 = store.organizations;
  if ($ instanceof Some) {
    if ($1 instanceof $remote.NotLoaded) {
      return new None();
    } else if ($1 instanceof $remote.Loading) {
      return new None();
    } else if ($1 instanceof $remote.Errored) {
      return new None();
    } else {
      let org_id = $[0];
      let organizations = $1[0][1];
      let $2 = $list.find(organizations, (org) => { return org.id === org_id; });
      if ($2 instanceof Ok) {
        let organization = $2[0];
        return new Some(organization);
      } else {
        return new None();
      }
    }
  } else {
    return $;
  }
}

export function organization_name_from_id(store, organization_id) {
  let $ = store.organizations;
  if ($ instanceof $remote.NotLoaded) {
    return "";
  } else if ($ instanceof $remote.Loading) {
    return "";
  } else if ($ instanceof $remote.Errored) {
    return "";
  } else {
    let organizations = $[0][1];
    let _pipe = organizations;
    let _pipe$1 = $list.filter(
      _pipe,
      (org) => { return org.id === organization_id; },
    );
    let _pipe$2 = $list.first(_pipe$1);
    let _pipe$3 = $option.from_result(_pipe$2);
    let _pipe$4 = $option.map(_pipe$3, (org) => { return org.display_name; });
    return $option.unwrap(_pipe$4, "");
  }
}

export function set_organization(store, organization) {
  return new Store(
    store.connections,
    store.organizations,
    store.organizations_tags,
    store.organizations_users,
    store.organizations_invitations,
    store.organizations_enabled_connections,
    store.organizations_ai_config,
    store.organizations_qm_rows,
    store.connected_sockets,
    store.projects,
    store.proposals,
    store.page_index,
    store.proposal_elements,
    store.answers,
    store.translations,
    store.label_translations,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
    store.llm_rate_limits,
    store.organizations_activity,
    store.llm_usage,
    store.llm_usage_by_org,
    store.client,
    organization,
    store.route,
    store.user,
    store.user_id,
    store.content_library,
    store.ingestion_control_sources,
    store.ingestion_control_sources_visibility,
    store.loading,
    store.users,
    store.roles,
    store.maintenance_mode,
    store.data_sources,
    store.analytics,
    store.metrics_groups,
    store.dashboard_options,
    store.project_files,
    store.weaviate_migrations,
    store.weaviate_collections,
    store.sitemap_urls,
  );
}

export function set_default_organization(store) {
  let $ = store.organization;
  let $1 = store.organizations;
  let $2 = store.user;
  if ($ instanceof Some) {
    return store;
  } else if ($2 instanceof Some) {
    if ($1 instanceof $remote.NotLoaded) {
      return store;
    } else if ($1 instanceof $remote.Loading) {
      return store;
    } else if ($1 instanceof $remote.Errored) {
      return store;
    } else {
      let user = $2[0];
      return new Store(
        store.connections,
        store.organizations,
        store.organizations_tags,
        store.organizations_users,
        store.organizations_invitations,
        store.organizations_enabled_connections,
        store.organizations_ai_config,
        store.organizations_qm_rows,
        store.connected_sockets,
        store.projects,
        store.proposals,
        store.page_index,
        store.proposal_elements,
        store.answers,
        store.translations,
        store.label_translations,
        store.label_translations_search,
        store.label_translations_language_filter,
        store.label_translations_sort,
        store.llm_rate_limits,
        store.organizations_activity,
        store.llm_usage,
        store.llm_usage_by_org,
        store.client,
        user.org_id,
        store.route,
        store.user,
        store.user_id,
        store.content_library,
        store.ingestion_control_sources,
        store.ingestion_control_sources_visibility,
        store.loading,
        store.users,
        store.roles,
        store.maintenance_mode,
        store.data_sources,
        store.analytics,
        store.metrics_groups,
        store.dashboard_options,
        store.project_files,
        store.weaviate_migrations,
        store.weaviate_collections,
        store.sitemap_urls,
      );
    }
  } else if ($1 instanceof $remote.NotLoaded) {
    return store;
  } else if ($1 instanceof $remote.Loading) {
    return store;
  } else if ($1 instanceof $remote.Errored) {
    return store;
  } else {
    let organizations = $1[0][1];
    return new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      store.label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      (() => {
        let _pipe = organizations;
        let _pipe$1 = $list.first(_pipe);
        let _pipe$2 = $option.from_result(_pipe$1);
        return $option.map(_pipe$2, (org) => { return org.id; });
      })(),
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
  }
}

export function org_collections(store, org_id) {
  let _block;
  if (org_id instanceof Some) {
    let org_id$1 = org_id[0];
    let _pipe = $dict.get(store.weaviate_collections, org_id$1);
    _block = $result.unwrap(_pipe, new $remote.NotLoaded());
  } else {
    _block = new $remote.NotLoaded();
  }
  let collections = _block;
  if (collections instanceof $remote.Loaded) {
    let cols = collections[0];
    return [cols, true];
  } else {
    return [toList([]), false];
  }
}

function organization_data(store, data) {
  let _pipe = store.organization;
  let _pipe$1 = $option.to_result(_pipe, undefined);
  let _pipe$2 = $result.try$(
    _pipe$1,
    (_capture) => { return $dict.get(data, _capture); },
  );
  return $result.unwrap(_pipe$2, new $remote.NotLoaded());
}

export function organization_users(store) {
  let users = store.organizations_users;
  return organization_data(store, users);
}

export function organization_tags(store) {
  let tags = store.organizations_tags;
  return organization_data(store, tags);
}

export function organization_enabled_connections(store) {
  let connections = store.organizations_enabled_connections;
  return organization_data(store, connections);
}

export function organization_invitations(store) {
  let invitations = store.organizations_invitations;
  return organization_data(store, invitations);
}

export function organization_ai_config(store) {
  let ai_configs = store.organizations_ai_config;
  return organization_data(store, ai_configs);
}

export function organization_qm_rows(store) {
  let qm_rows = store.organizations_qm_rows;
  return organization_data(store, qm_rows);
}

export function organization_weaviate_migrations(store) {
  let weaviate_migrations = store.weaviate_migrations;
  return organization_data(store, weaviate_migrations);
}

export function organization_weaviate_collections(store) {
  let weaviate_collections = store.weaviate_collections;
  return organization_data(store, weaviate_collections);
}
